import { useAppSelector } from 'state/store';
import { getCurrentConsumptionModeType, getRestaurantId } from 'state/app';
import { getMenuState } from 'state/menu';
import { ProductAttributesFromCategories } from 'services/menu/menu.type';
import { useTableNumber } from 'hooks/useTableNumber/useTableNumber';
import { getIsProductDisplayedWhenUnavailable } from 'state/brand';
import { computeProductList } from './ProductList.utils';

export const useProductListVM = (productList: ProductAttributesFromCategories[]) => {
    const currentConsumptionModeType = useAppSelector(getCurrentConsumptionModeType);
    const menu = useAppSelector(getMenuState);
    const restaurantId = useAppSelector(getRestaurantId);

    const isProductDisplayedWhenUnavailable = useAppSelector(
        getIsProductDisplayedWhenUnavailable(restaurantId),
    );

    const computedProductList = computeProductList(
        productList,
        currentConsumptionModeType,
        menu,
        isProductDisplayedWhenUnavailable,
    );

    const { tableNumber } = useTableNumber();

    return {
        computedProductList,
        tableNumber,
    };
};
